module.exports = __webpack_public_path__ + "img/9791188850426.187a7e01.jpg";